module.exports = __webpack_public_path__ + "static/media/instant_fisdom.676359fa.svg";